import { useCallback } from 'react';

import validateChallengeAnswer from '../validateChallengeAnswer';

export const useValidateChallengeAnswer = ({ onValidate, onError: onErrorExternal, operation, widgetId }) =>
    useCallback((response) => {
        const { token: responseToken } = response;

        const onError = (error) => {
            onErrorExternal(error);

            if (widgetId != null) {
                window.grecaptcha?.reset(widgetId);
            }
        };

        validateChallengeAnswer({ responseToken, onValidate, onError, operation });
    }, [onValidate, onErrorExternal, operation, widgetId]);
